import { render, staticRenderFns } from "./BottomImage.vue?vue&type=template&id=57e8b03f"
import script from "./BottomImage.vue?vue&type=script&lang=js"
export * from "./BottomImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports